import { PLAIN_TEXT } from '@atlassian/jira-issue-shared-types/src/common/types/field-schema-type.tsx';
import { SPRINT_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { FieldTransformer } from '../types/transformer-type.tsx';
import {
	transformAggConnection,
	transformAggNodeToLegacyField,
} from './default-node-transformer.tsx';

const SprintOptionalKeyMap = {
	goal: 'goal',
	completeDate: 'completionDate',
	startDate: 'startDate',
	endDate: 'endDate',
};

// @ts-expect-error TODO JPX-157
const transformAggSprintToLegacySprint = (sprint) => {
	const optionalValues = {};

	Object.keys(SprintOptionalKeyMap).forEach((key) => {
		// @ts-expect-error TODO JPX-157
		const aggKey = SprintOptionalKeyMap[key];
		const aggValue = sprint[aggKey];

		if (aggValue !== undefined && aggValue !== null) {
			// @ts-expect-error TODO JPX-157
			optionalValues[key] = aggValue;
		}
	});

	return {
		id: Number(sprint.sprintId),
		name: sprint?.name ?? '',
		state: sprint.state?.toLowerCase(),
		boardId: Number(sprint.boardName) || 0,
		...optionalValues,
	};
};

export const transformAggSprintToLegacyField: FieldTransformer<typeof SPRINT_TYPE> = (node) => {
	if (node.type !== SPRINT_TYPE) return undefined;

	const sprints = transformAggConnection(
		node.selectedSprintsConnection,
		transformAggSprintToLegacySprint,
	);

	return {
		...transformAggNodeToLegacyField(node),
		value: sprints,
		schema: {
			configuration: null,
			custom: SPRINT_TYPE,
			items: 'json',
			renderer: PLAIN_TEXT,
			system: null,
			type: 'array',
		},
	};
};
